module.exports = __webpack_public_path__ + "static/githuboctocat-1ecd424b6ebd42a7cc84ef0a61adbf11.svg";